export default __webpack_public_path__ + "static/media/edit-light.d5d11d78.svg";